import React from 'react'
import { Radio as AntdRadio } from 'antd'
import { COLORS } from 'theme'
import styled from 'styled-components'

const StyledDiv = styled.div`
  ${props => props.width && `width: ${props.width};`}
  ${props => props.minWidth && `min-width: ${props.minWidth};`}
  .ant-radio-wrapper-checked {
    border-color: ${COLORS.PRIMARY};
    font-weight: 700;   
    color: #000000;
  }
`
const StyledRadio = styled(AntdRadio)`
margin-top: 10px;
height : 48px;
  width: ${props => (props.radioWidth ? props.radioWidth : '175px')};

  font-weight: 600;
  font-size: ${props => (props.fontSize ? props.fontSize : '14px')};
  line-height: 24px;

  color: #B1B1B1;
  background-color: white;
  border: ${props => props.border && '1px solid #e6e7ea'};
  border-radius: 10px;

  padding: ${props => (props.padding ? props.padding : '10px 15px')};
  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: none !important;
  }

  .ant-radio-checked .ant-radio-inner::after {
    transform: scale(0.75);
  }
  .ant-radio-inner {
    background-color: transparent;
  }
`

const RadioButton = ({
  onChange,
  label,
  extraLabel,
  border = false,
  width,
  minWidth,
  ...rest
}) => {
  return (
    <StyledDiv width={width} minWidth={minWidth}>
      <StyledRadio border={border} onChange={onChange} {...rest}>
        {label} {extraLabel}
      </StyledRadio>
    </StyledDiv>
  )
}
export default RadioButton
